import React, { Component } from 'react';

import MapUtils from './map-utils';
import Map from './map-react';
import Geocoder from '../geocoder';
import Tooltip from '../tooltip';
import './map.styl';

class MapWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipVisible: false,
      tooltipPos: false,
      tooltipData: false,
      isMapActive: true,
      geocoderLatLng: []
    };
  }

  componentDidMount() {
    this.setMapActive(this.state.isMapActive);
  }

  updateState = (nextState) => {
    this.setState(nextState);
  }

  onGeocoderSuccess = (res) => {
    const latlng = res.response.view[0].result[0].location.displayPosition;
    this.setState({ geocoderLatLng: [latlng.latitude, latlng.longitude] });
    this.map.setView({
      center: [latlng.latitude, latlng.longitude]
    });
  }

  toggleMapActive = () => {
    if (!this.map) {
      return false;
    }

    const { isMapActive } = this.state;

    this.setMapActive(isMapActive);
    this.setState({ isMapActive: !isMapActive });
  }

  // if map is disabled user can't zoom by scroll
  setMapActive(isActive) {
    if (!this.map) {
      return false;
    }

    if (isActive) {
      MapUtils.disableMap(this.map.map.leafletElement);
    } else {
      MapUtils.enableMap(this.map.map.leafletElement);
    }
  }

  render() {
    return (
      <div className="map-comp-wrapper">
        <a href="http://mapbox.com/about/maps" className="mapbox-maplogo" target="_blank">Mapbox</a>
        <Map
          updateState={this.updateState}
          geocoderLatLng={this.state.geocoderLatLng}
          config={this.props.config}
          ref={ref => { this.map = ref; }}
          isMapActive={this.state.isMapActive}
          toggleMapActive={this.toggleMapActive}
        />
        <Tooltip
          visible={this.state.tooltipVisible}
          pos={this.state.tooltipPos}
          data={this.state.tooltipData}
        />
        {this.props.showGeocoder &&
          <Geocoder
            onSelect={this.onGeocoderSuccess}
          />
        }
      </div>
    )
  }
}

MapWrapper.defaultProps = {
  showGeocoder: true
}

export default MapWrapper;
